<template>
  <b-modal id="modal-dialog" ref="modal-dialog" size="xl" :title="title" @hidden="clearModalData">
    <!-- playlist picker modal -->
    <PlaylistsViewer v-if="show" :key="playlistType" :picker-mode="true" :playlist-type="playlistType"
      :orientation="orientation" @item-clicked="selectPlaylist" />
    <!-- modal buttons -->
    <div slot="modal-footer" class="w-100">
      <b-button variant="light" v-if="cancelText" class="float-right mx-2" @click="modalCancel">{{ cancelText
        }}</b-button>
    </div>
  </b-modal>
</template>

<script>
import PlaylistsViewer from '@/components/PlaylistsViewer.vue';
import mediaMixin from '@/views/admin/media/mediaMixin';

export default {
  mixins: [mediaMixin],
  components: {
    PlaylistsViewer,
  },
  data() {
    return {
      show: false,
      title: 'Choose a playlist',
      cbConfirm: null,
      cancelText: 'Cancel',
      playlistType: 'playlists',
      orientation: 1,
    };
  },
  created() {
    this.$root.$on('modal-show-playlist-picker', this.showModal);
  },
  beforeDestroy() {
    this.$root.$off('modal-show-playlist-picker', this.showModal);
  },
  methods: {
    showModal({
      cbConfirm,
      playlistType,
      orientation,
    }) {
      this.show = true;
      this.cbConfirm = cbConfirm || null;
      this.playlistType = playlistType;
      this.orientation = orientation; // 0 - landscape, 1 - portrait
      this.$refs['modal-dialog'].show();
    },
    hideModal() {
      this.$refs['modal-dialog'].hide();
    },
    clearModalData() {
      this.show = false;
      this.title = 'Choose a playlist';
      this.cbConfirm = null;
      this.cancelText = 'Cancel';
      this.playlistType = 'playlists';
      this.orientation = 1;
    },
    modalConfirm(data) {
      if (this.cbConfirm) {
        this.cbConfirm(data);
      }
      this.hideModal();
    },
    modalCancel() {
      if (this.cbCancel) this.cbCancel();
      this.hideModal();
    },
    selectPlaylist($event) {
      this.modalConfirm($event);
    },
  },
};
</script>
